import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserSubscription, UserSubscriptionCategory, UserSubscriptionType} from "../../../../user/user-subscription";


@Component({
    selector: 'db-premium-plugin-upgrade-plan-item',
    templateUrl: './premium-plugin-upgrade-plan-item.component.html',
    styleUrls: ['./premium-plugin-upgrade-plan-item.component.scss'],
    standalone: false
})
export class PremiumPluginUpgradePlanItemComponent implements OnInit {
  public UserSubscriptionCategory: any = UserSubscriptionCategory;
  public UserSubscriptionType: any = UserSubscriptionType;

  public extensionCount: string;
  public pluginsCount: string;

  @Input() subscription: UserSubscription;
  @Input() planDescription: any;
  @Input() product: any;
  @Output() onChooseSubscription: EventEmitter<any>;

  constructor() {
    this.onChooseSubscription = new EventEmitter<any>();
  }

  ngOnInit() {
    this.extensionCount = this.planDescription && this.planDescription.mainFeatures[1] ? this.planDescription.mainFeatures[1].title.split("Premium")[0] : 0;
    this.pluginsCount = this.planDescription && this.planDescription.mainFeatures[0] && this.planDescription.mainFeatures[0].title ? this.planDescription.mainFeatures[0].title.split("Premium")[0] : 0;
  }

  public chooseSubscription(): void {
    this.onChooseSubscription.emit(this.subscription);
  }
}
